module.exports = "images/location_gas_station.4cb97fe23f10ffcd162be2e65b511a99.png";